import { createFileRoute, Link } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { ThumbsUp, ThumbsDown, ArrowLeft } from "lucide-react";
import { listArticulosNews } from "@/lib/articulos.functions";

export const Route = createFileRoute("/blog")({
  head: () => ({
    meta: [
      { title: "Blog Bizaclia — Traspasos, alquileres y franquicias" },
      {
        name: "description",
        content:
          "Noticias, análisis y consejos sobre traspasos, alquileres y franquicias del mercado inmobiliario comercial.",
      },
      { property: "og:title", content: "Blog Bizaclia" },
      {
        property: "og:description",
        content:
          "Noticias, análisis y consejos sobre traspasos, alquileres y franquicias.",
      },
      { property: "og:url", content: "/blog" },
    ],
    links: [{ rel: "canonical", href: "/blog" }],
  }),
  component: BlogPage,
});

function BlogPage() {
  const fn = useServerFn(listArticulosNews);
  const { data, isLoading } = useQuery({
    queryKey: ["blog"],
    queryFn: () => fn(),
  });

  return (
    <main className="mx-auto max-w-5xl px-4 py-10">
      <Link
        to="/"
        className="mb-6 inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="h-4 w-4" /> Volver al inicio
      </Link>

      <header className="mb-8">
        <h1 className="text-4xl font-bold tracking-tight">Blog Bizaclia</h1>
        <p className="mt-2 text-muted-foreground">
          Artículos, novedades y guías sobre el mercado inmobiliario comercial.
        </p>
      </header>

      {isLoading && <p className="text-muted-foreground">Cargando…</p>}

      <ul className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {data?.map((a) => (
          <li
            key={a.id}
            className="overflow-hidden rounded-lg border border-border bg-background transition-shadow hover:shadow-md"
          >
            <Link to="/news/$slug" params={{ slug: a.slug }} className="block">
              {a.cover_url ? (
                <img
                  src={a.cover_url}
                  alt=""
                  className="aspect-video w-full object-cover"
                  loading="lazy"
                />
              ) : (
                <div className="aspect-video w-full bg-muted" />
              )}
              <div className="p-4">
                <h2 className="text-lg font-semibold leading-snug">{a.titulo}</h2>
                <div className="mt-3 flex items-center gap-4 text-xs text-muted-foreground">
                  <span className="capitalize">{a.autor_tipo}</span>
                  {a.published_at && (
                    <time dateTime={a.published_at}>
                      {new Date(a.published_at).toLocaleDateString("es-ES", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })}
                    </time>
                  )}
                  <span className="ml-auto inline-flex items-center gap-1">
                    <ThumbsUp className="h-3.5 w-3.5" /> {a.likes}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <ThumbsDown className="h-3.5 w-3.5" /> {a.dislikes}
                  </span>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>

      {!isLoading && data && data.length === 0 && (
        <div className="rounded-lg border border-dashed border-border p-12 text-center text-muted-foreground">
          Aún no hay artículos publicados.
        </div>
      )}
    </main>
  );
}
